<script lang="ts" setup>
import { computed, inject, onUnmounted, ref, type PropType } from 'vue';

import { CONSTANTS } from '@exchange/libs/utils/constants/src';

const props = defineProps({
  date: {
    type: Date as PropType<Date>,
    required: true,
  },
  format: {
    type: String,
  },
  forceAbsoluteTime: {
    type: Boolean,
    default: false,
  },
});

const utcToLocal = inject<(utcDateString: string | Date | number, formatString?: string) => string>('utcToLocal');

const now = ref(Date.now());
const dateFormat = computed(() => props.format || CONSTANTS.DATE_FORMAT);
const noFuture = computed(() => {
  const time = props.date.getTime();

  return time > now.value ? now.value : time;
});
const showAbsoluteTime = computed(() => Date.now() - props.date.getTime() > 1000 * 60 * 60 * 24);

const updateNow = () => {
  now.value = Date.now();
};

const interval = setInterval(() => updateNow(), 1000);

onUnmounted(() => clearInterval(interval));
</script>

<template>
  <span class="time-from-now">
    <template v-if="forceAbsoluteTime || showAbsoluteTime">
      <span class="x-from-now__absolute">{{ utcToLocal(date, dateFormat) }}</span>
    </template>
    <template v-else>
      <span class="x-from-now__relative">{{ utcToLocal(noFuture, 'fromNow') }}</span>
    </template>
  </span>
</template>
